import { AlreadyExistsError, NotFoundError } from 'activate-errors';
import { BaseType } from '../types/baseTypes/TypeBase';
import { TypeInterface } from '../types/baseTypes/TypeInterface';
import { PropertyType } from '../types/properties/Property';

/**
 * @deprecated This interface is deprecated and should not be used in new code.
 * Use TypesCollection from application-types instead.
 */
export interface TypesCollection {
  [key: string]: TypeInterface;
}

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use Types from application-types instead.
 */
export default class Types {
  static baseTypes: TypesCollection = {};

  static types: TypesCollection = {};

  /**
   * @deprecated This method is deprecated and should not be used in new code.
   * Use addBaseType from application-types instead.
   */
  static addBaseType(definition: TypeInterface) {
    if (this.baseTypes[definition.name]) {
      throw new AlreadyExistsError(
        `Base Type:${definition.name} already added.`
      );
    }

    this.baseTypes[definition.name] = definition;
    this.types[definition.name] = definition;
  }

  /**
   * @deprecated This method is deprecated and should not be used in new code.
   * Use addType from application-types instead.
   */
  static addType(definition: TypeInterface) {
    if (this.types[definition.name]) {
      throw new AlreadyExistsError(`Type:${definition.name} already added.`);
    }

    // todo: validate the type definition?
    this.types[definition.name] = definition;
  }

  /**
   * @deprecated This method is deprecated and should not be used in new code.
   * Use create from application-types instead.
   */
  static create(config: PropertyType): BaseType {
    if (!this.types[config.type]) {
      throw new NotFoundError(`Type:${config.type} not found.`);
    }

    const cls = this.types[config.type].constructor;
    const type = new (cls as any)();

    type.config = config;

    return type;
  }

  /**
   * @deprecated This method is deprecated and should not be used in new code.
   * Use getType from application-types instead.
   */
  static getType(name: string): TypeInterface {
    if (!this.types[name]) {
      throw new NotFoundError(`Type:${name} not found.`);
    }

    return this.types[name];
  }

  /**
   * @deprecated This method is deprecated and should not be used in new code.
   * Use getBaseTypes from application-types instead.
   */
  static getBaseTypes(): TypesCollection {
    return this.baseTypes;
  }

  /**
   * @deprecated This method is deprecated and should not be used in new code.
   * Use isType from application-types instead.
   */
  static isType(name: any): boolean {
    return !!this.types[name];
  }

  /**
   * @deprecated This method is deprecated and should not be used in new code.
   * Use isBaseType from application-types instead.
   */
  static isBaseType(name: any): boolean {
    return !!this.baseTypes[name];
  }

  /**
   * @deprecated This method is deprecated and should not be used in new code.
   * Use isAdvancedType from application-types instead.
   */
  static isAdvancedType(name: any): boolean {
    return !!this.types[name] && !this.baseTypes[name];
  }

  /**
   * @deprecated This method is deprecated and should not be used in new code.
   * Use getTypes from application-types instead.
   */
  static getTypes(): TypesCollection {
    return this.types;
  }
}
